import { setLocale } from "yup";
import { suggestive } from "yup-locale-ja";

setLocale(suggestive);
